import { useRef, useState, useEffect } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
// @mui
import { alpha } from '@mui/material/styles';
import { Box, Divider, Typography, Stack, MenuItem, Avatar, IconButton, ListItemIcon, Switch } from '@mui/material';
// components
import MenuPopover from '../../components/MenuPopover';
import Iconify from '../../components/Iconify';
// mocks_
// import account from '../../_mock/account';
import PropTypes from 'prop-types';
import { setDeleteToken } from 'src/api/vehicles';
import { useColorMode } from 'src/theme';

import { clearSessionScopedStorage } from 'src/utils/storageProxy';

import { buildAuthSnapshot, getPersistedAuthSnapshot, publishLogoutSyncEvent } from 'src/utils/authSync';

import PersonIcon from '@mui/icons-material/Person';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import apiAxios from '../../axios';
import { hasDashboardPageAccess } from 'src/utils/dashboardAccess';

// ----------------------------------------------------------------------

const MENU_OPTIONS = [
  {
    label: 'Dashboard',
    icon: 'eva:home-fill',
    linkTo: '/',
  }
  // {
  //   label: 'Settings',
  //   icon: 'eva:settings-2-fill',
  //   linkTo: '/analytics',
  // },
];





// ----------------------------------------------------------------------

export default function AccountPopover({setToken, setUserType}) {
  const { mode, toggleColorMode } = useColorMode();
  const [options,setOptions] = useState([])
  useEffect(()=>{
    const showDashboard = hasDashboardPageAccess();
    // console.log("menu usertype",localStorage.getItem('client_type'))
    const user_type=localStorage.getItem('client_type');
    const filteredOptions = showDashboard
      ? MENU_OPTIONS
      : MENU_OPTIONS.filter((option) => option.label !== 'Dashboard');
    if(user_type==='US'){
      setOptions(filteredOptions.filter(option => option.label !== 'Settings'));
    }
    else{
      setOptions(filteredOptions)
    }
  },[])
  

  const anchorRef = useRef(null);

  const [open, setOpen] = useState(null);
  const navigate = useNavigate();
  //const [showSettings,setShowSettings] = useState(true)

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const handleLogout = () => {
    let client_id = localStorage.getItem('client_id');

    let redirect_url = '/login'
    if(client_id === "1320"){
      redirect_url = "/signin";
    }

    let fcm_token = localStorage.getItem('FCM_TOKEN')
    if(fcm_token){
      const token ={
        token : fcm_token
      }

      // setDeleteToken(token,(response) =>{
      //   if(response.status === 200){
      //     removeLocalStorage()
      //   }
      // })

        // Best-effort token unregister; logout must not depend on this call.
        try {
          setDeleteToken(token, () => {})
        } catch (error) {
          // Ignore and continue logout cleanup.
        }
    }
    // } else {
    //   removeLocalStorage();
    // }

    removeLocalStorage()
    
    // console.log('Logout')
    setToken(null)
    // setUserType(null)
    navigate(redirect_url, { replace: true })
  }

  const removeLocalStorage = () => {
    const authSnapshot = getPersistedAuthSnapshot() || buildAuthSnapshot();
    publishLogoutSyncEvent(authSnapshot);
    clearSessionScopedStorage();
  }

  // const removeLocalStorage = () => {
  //   const keysToKeep = ['rememberedUsername', 'rememberedPassword', 'NetLocation', 'netIP', 'theme_mode'];

  //   // Get all keys from localStorage
  //   const allKeys = Object.keys(localStorage);

  //   // Remove keys that are not in the keep list
  //   allKeys.forEach(key => {
  //     if (!keysToKeep.includes(key)) {
  //       localStorage.removeItem(key);
  //     }
  //   });

  //   delete apiAxios.defaults.headers.common.Authorization;
  // }

  const [user, setUser] = useState({
    displayName: '',
    photoURL: '',
    role: '',
    email: '',
    displayLatter:'',
    location: '',
  })


  useEffect(() => {
   const displayName = localStorage.getItem('profile_name');
    let displayLatter = displayName ? displayName.charAt(0).toUpperCase() : ''
    let photoURL = !displayName ? '/static/mock-images/avatars/avatar_default.jpg' : ''
    const location = localStorage.getItem('Location');
    setUser({...user, displayName, displayLatter, photoURL, location})
  }, [localStorage.getItem('profile_name')])
 
  //const client_id = localStorage.getItem('client_id');

  const logo_url = localStorage.getItem('logo_url');
  // console.log('logo_url:', logo_url);

  const [imgError, setImgError] = useState(false);
  const ID = localStorage.getItem('ID');
  //const image_base_path = 'https://vdointel-ai-storage.s3.us-west-2.amazonaws.com/uploads/client_logos/';
  //const user_logo =  (client_id === "1316") ? `${image_base_path}timberland_user.png` : (client_id === "1320") ? `${image_base_path}groves_user.png` : logo_url;
  const user_logo = logo_url;

  // console.log('user:', JSON.stringify(user))
  
  return (
    <>
      <IconButton
        ref={anchorRef}
        onClick={handleOpen}
        sx={{
          p: 0,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      >
        {/* <Avatar src={account.photoURL} alt="photoURL" /> */}
{/* <Avatar>
  <img 
    src="/static/gym.png" 
    alt="Avatar" 
    style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
  />
</Avatar> */}


    <Avatar
      sx={{
        bgcolor: '#ffffff',
        color: 'primary.main',
        width: 56,
        height: 56,
        borderRadius: '50%',
        overflow: 'hidden',
      }}
    >
      {user_logo && !imgError ? (
        <img
          src={user_logo}
          alt="Client Avatar"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            borderRadius: '50%',
          }}
          onError={() => setImgError(true)}
        />
      ) : (
        <PersonIcon />
      )}
    </Avatar>

      </IconButton>

      <MenuPopover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        sx={{
          p: 0,
          mt: 1.5,
          ml: 0.75,
          width: 300,
          '& .MuiMenuItem-root': {
            typography: 'body2',
            borderRadius: 0.75,
          },
        }}
      >
        <Box
          sx={{
            px: 2,
            py: 2.25,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            textAlign: 'center',
            gap: 1.25,
            background: (theme) =>
              `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.16)} 0%, ${alpha(theme.palette.primary.main, 0.04)} 100%)`,
          }}
        >
          <Avatar sx={{ width: 58, height: 58, bgcolor: 'primary.main', color: 'primary.contrastText' }}>
            {user_logo && !imgError ? (
              <img
                src={user_logo}
                alt="Profile"
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                onError={() => setImgError(true)}
              />
            ) : (
              <PersonIcon />
            )}
          </Avatar>
          <Box sx={{ minWidth: 0 }}>
            <Typography
              variant="subtitle1"
              sx={{ textTransform: ID !== "1302" ? "capitalize" : undefined }}
              noWrap
            >
              {user.displayName || 'User'}
            </Typography>
            {user.location && (
              <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
                {user.location || 'No location'}
              </Typography>
            )}
          </Box>
        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <Stack sx={{ p: 1 }}>
          {options.length>0 && options.map((option) => (
            <MenuItem key={option.label} to={option.linkTo} component={RouterLink} onClick={handleClose}>
              <ListItemIcon sx={{ minWidth: 28, color: 'text.secondary' }}>
                <Iconify icon={option.icon} width={18} height={18} />
              </ListItemIcon>
              {option.label}
            </MenuItem>
          ))}
        </Stack>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <MenuItem onClick={toggleColorMode} sx={{ mx: 1, mt: 1, display: 'flex', alignItems: 'center' }}>
          <ListItemIcon sx={{ minWidth: 28 }}>
            {mode === 'dark' ? <DarkModeIcon fontSize="small" /> : <LightModeIcon fontSize="small" />}
          </ListItemIcon>
          <Typography variant="body2" sx={{ flexGrow: 1 }}>
            {mode === 'dark' ? 'Dark Mode' : 'Light Mode'}
          </Typography>
          <Switch
            size="small"
            checked={mode === 'dark'}
            onClick={(e) => e.stopPropagation()}
            onChange={(e) => {
              e.stopPropagation();
              toggleColorMode();
            }}
          />
        </MenuItem>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <MenuItem onClick={handleLogout} sx={{ m: 1, display: 'flex', alignItems: 'center' }}>
          <ListItemIcon sx={{ minWidth: 28, color: 'error.main', display: 'flex', alignItems: 'center' }}>
            <LogoutRoundedIcon fontSize="small" />
          </ListItemIcon>
          <Typography variant="body2">Logout</Typography>
        </MenuItem>
      </MenuPopover>
    </>
  );
}

AccountPopover.propTypes = {
  setToken: PropTypes.func.isRequired
}
